import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Field, withTypes } from 'react-final-form';
import { Button, ButtonToolbar } from 'reactstrap';
import CustomInputField from '../../../components/form/CustomInputField';
import CustomSelect from '../../../components/form/CustomSelect';
import DatePickerRegistration from '../../../components/form/DatePickerRegistration';
import { useDict } from '../../../contexts/LanguageContext';
import { checkIsDobOverLimit } from '../../../utils/dateHelper';
import { getRegistrationDropdownList } from '../src/registrationApis';

const PersonalDetails = (props) => {
    const { onSubmit, isLoading, personalDetailsSubmittedData } = props;

    const dict = useDict();

    const gender = [
        { value: 1, label: dict.male },
        { value: 2, label: dict.female },
    ];
    const [residentialAddress, setResidentialAddress] = useState(false);
    const [nationalities, setNationalities] = useState([]);
    const [countries, setCountries] = useState([]);
    const [provinces, setProvinces] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getDropdownList();
    }, []);

    const { Form } = withTypes();

    const handleDropdownListResponse = (response) => {
        const { data: responseData } = response.data;
        setNationalities(responseData.citizenships);
        setCountries(responseData.countries);
        setProvinces(responseData.provinces);
    };

    const getDropdownList = () => {
        getRegistrationDropdownList(handleDropdownListResponse);
    };

    const personalDetailValidate = (values) => {
        const errors = {};
        // if (!values.amount_invest_id) {
        //   errors.amount_invest_id = 'Amount to Invest field should not be empty.';
        // }
        if (!values.address_line_one) {
            errors.address_line_one = dict.addressLine1Empty;
        }
        if (!values.dob) {
            errors.dob = dict.dobEmpty;
        } else if (checkIsDobOverLimit(values.dob)) {
            errors.dob = dict.dobInvalid;
        }
        if (!values.city) {
            errors.city = dict.cityEmpty;
        }
        if (!values.postcode) {
            errors.postcode = dict.postcodeEmpty;
        }
        if (!values.province_id) {
            errors.province_id = dict.provinceEmpty;
        }
        if (!values.country_id) {
            errors.country_id = dict.countryEmpty;
        }
        if (!values.gender_id) {
            errors.gender_id = dict.genderEmpty;
        }
        if (!values.citizen_id) {
            errors.citizen_id = dict.nationalityEmpty;
        }
        // if (!values.check_differ_address) {
        //     if (!values.res_address_line_one) {
        //         errors.res_address_line_one =
        //             'Address line one field should not be empty.';
        //     }
        //     if (!values.res_city) {
        //         errors.res_city = 'City field should not be empty.';
        //     }
        //     if (!values.res_postcode) {
        //         errors.res_postcode = 'Postcode field should not be empty.';
        //     }
        //     if (!values.res_province_id) {
        //         errors.res_state = 'Province field should not be empty.';
        //     }
        //     if (!values.res_country_id) {
        //         errors.res_country_id = 'Country field should not be empty.';
        //     }
        // }

        return errors;
    };

    return (
        <Form
            initialValues={{
                gender_id: personalDetailsSubmittedData.gender_id ? personalDetailsSubmittedData.gender_id : 1,
                dob: personalDetailsSubmittedData.dob ? personalDetailsSubmittedData.dob : null,
                address_line_one: personalDetailsSubmittedData.address_line_one ? personalDetailsSubmittedData.address_line_one : '',
                address_line_two: personalDetailsSubmittedData.address_line_two ? personalDetailsSubmittedData.address_line_two : '',
                city: personalDetailsSubmittedData.city ? personalDetailsSubmittedData.city : '',
                postcode: personalDetailsSubmittedData.postcode ? personalDetailsSubmittedData.postcode : '',
                province_id: personalDetailsSubmittedData.province_id ? personalDetailsSubmittedData.province_id : 4,
                country_id: personalDetailsSubmittedData.country_id ? personalDetailsSubmittedData.country_id : 1,
                citizen_id: personalDetailsSubmittedData.citizen_id ? personalDetailsSubmittedData.citizen_id : 1
            }}
            validate={personalDetailValidate}
            onSubmit={(values) => onSubmit(values)}
        >
            {({ handleSubmit }) => {
                return (
                    <form
                        className="form wizard__form_2"
                        onSubmit={handleSubmit}
                    >
                        {/* <div className="form__form-group">
                            <div className="form__form-group-field">
                                <div className="form__form-group-input-wrap">
                                    <Field name="amount_invest_id">
                                        {({ input, meta }) => (
                                            <CustomSelect
                                                input={input}
                                                meta={meta}
                                                // options={
                                                //     registrationDropdownList.interested_amount_to_invest
                                                // }
                                                options={
                                                    [
                                                        {value:1, label:'test'}
                                                    ]
                                                }
                                                placeholder="Amount to Invest *"
                                                isClearable
                                                data-cy="personalDetails__investAmount"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div> */}
                        <div
                            className="form__form-group bottom-border-dashed"
                        >
                            <div
                                className="card__title"
                                style={{ marginBottom: '5px' }}
                            >
                                <h4
                                    className="bold-text"
                                    style={{ fontSize: '14px' }}
                                >
                                    {dict.general}
                                </h4>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <div className="form__form-group-input-wrap">
                                    <Field name="gender_id">
                                        {({ input, meta }) => (
                                            <CustomSelect
                                                input={input}
                                                meta={meta}
                                                options={gender}
                                                placeholder={dict.gender + " *"}
                                                isClearable
                                                data-cy="personalDetails__gender"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-input-wrap">
                                <Field name="dob">
                                    {({ input, meta }) => (
                                        <DatePickerRegistration
                                            input={input}
                                            meta={meta}
                                            placeholder={dict.dateOfBirth + " *"}
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div
                            className="form__form-group bottom-border-dashed"
                        >
                            <div
                                className="card__title"
                                style={{ marginBottom: '5px' }}
                            >
                                <h4
                                    className="bold-text"
                                    style={{ fontSize: '14px' }}
                                >
                                    {dict.permanentAddress}
                                </h4>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div
                                className="form__form-group-field"
                                data-private
                            >
                                <Field name="address_line_one">
                                    {({ input, meta }) => (
                                        <CustomInputField
                                            input={input}
                                            meta={meta}
                                            placeholder={dict.addressLine1 + " *"}
                                            type="text"
                                            data-cy="personalDetails__addressLineOne"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div
                                className="form__form-group-field"
                                data-private
                            >
                                <Field name="address_line_two">
                                    {({ input, meta }) => (
                                        <CustomInputField
                                            input={input}
                                            meta={meta}
                                            placeholder={dict.addressLine2}
                                            type="text"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <Field name="city">
                                    {({ input, meta }) => (
                                        <CustomInputField
                                            input={input}
                                            meta={meta}
                                            placeholder={dict.city + " *"}
                                            type="text"
                                            data-cy="personalDetails__city"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <Field name="postcode">
                                    {({ input, meta }) => (
                                        <CustomInputField
                                            input={input}
                                            meta={meta}
                                            placeholder={dict.postcode + " *"}
                                            type="text"
                                            data-cy="personalDetails__postcode"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <Field name="province_id">
                                    {({ input, meta }) => (
                                        <CustomSelect
                                            input={input}
                                            meta={meta}
                                            options={provinces}
                                            placeholder={dict.province + " *"}
                                            isSearchable
                                            isClearable
                                            data-cy="personalDetails__province_id"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <div className="form__form-group-input-wrap">
                                    <Field name="country_id">
                                        {({ input, meta }) => (
                                            <CustomSelect
                                                input={input}
                                                meta={meta}
                                                options={countries}
                                                placeholder={dict.country + " *"}
                                                isSearchable
                                                isClearable
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div>
                        {/* <div className="form__form-group">
                            <div
                                className="form__form-group-field"
                                style={{ fontSize: '12px', marginTop: '5px' }}
                            >
                                <Field
                                    name="check_differ_address"
                                    type="checkbox"
                                >
                                    {({ input, meta }) => (
                                        <CustomCheckBox
                                            input={input}
                                            meta={meta}
                                            defaultChecked={false}
                                            label="Tick if your residential address is the same as above"
                                            data-cy="personalDetails__checkDifferAddress"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div
                            style={
                                residentialAddress
                                    ? { width: '100%', display: 'none' }
                                    : { width: '100%' }
                            }
                        >
                            <div
                                className="form__form-group bottom-border-dashed"
                            >
                                <div
                                    className="card__title"
                                    style={{ marginBottom: '5px' }}
                                >
                                    <h4
                                        className="bold-text"
                                        style={{ fontSize: '14px' }}
                                        data-cy="personalDetails__residentialAddress"
                                    >
                                        Residential Address
                                    </h4>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <div
                                    className="form__form-group-field"
                                    data-private
                                >
                                    <Field name="res_address_line_one">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                input={input}
                                                meta={meta}
                                                placeholder="Address line 1 *"
                                                type="text"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <div
                                    className="form__form-group-field"
                                    data-private
                                >
                                    <Field name="res_address_line_two">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                input={input}
                                                meta={meta}
                                                placeholder="Address line 2 (Optional)"
                                                type="text"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <div className="form__form-group-field">
                                    <Field name="res_city">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                input={input}
                                                meta={meta}
                                                placeholder="City *"
                                                type="text"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <div className="form__form-group-field">
                                    <Field name="res_postcode">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                input={input}
                                                meta={meta}
                                                placeholder="Postcode *"
                                                type="text"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <div className="form__form-group-field">
                                    <Field name="res_province_id">
                                        {({ input, meta }) => (
                                            <CustomSelect
                                                input={input}
                                                meta={meta}
                                                options={provinces}
                                                placeholder="Province *"
                                                isSearchable
                                                isClearable
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <div className="form__form-group-field">
                                    <div className="form__form-group-input-wrap">
                                        <Field name="res_country_id">
                                            {({ input, meta }) => (
                                                <CustomSelect
                                                    input={input}
                                                    meta={meta}
                                                    options={countries}
                                                    placeholder="Country *"
                                                    isSearchable
                                                    isClearable
                                                />
                                            )}
                                        </Field>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div
                            className="form__form-group bottom-border-dashed"
                        >
                            <div
                                className="card__title"
                                style={{ marginBottom: '5px' }}
                            >
                                <h4
                                    className="bold-text"
                                    style={{ fontSize: '14px' }}
                                >
                                    {dict.citizenship}
                                </h4>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <div className="form__form-group-input-wrap">
                                    <Field name="citizen_id">
                                        {({ input, meta }) => (
                                            <CustomSelect
                                                input={input}
                                                meta={meta}
                                                options={nationalities}
                                                placeholder={dict.nationality + " *"}
                                                isSearchable
                                                isClearable
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <ButtonToolbar className="form__button-toolbar wizard__toolbar justify-content-center">
                                <Button
                                    color="primary"
                                    className={`next btn_uni rounded ${isLoading && 'disabled'
                                        }`}
                                    type="submit"
                                    data-cy="personalDetails__submitBtn"
                                >
                                    {dict.next}
                                </Button>
                            </ButtonToolbar>
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};

export default PersonalDetails;
